import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { setUpCharts } from './charts/chart';
import './styles.css';

// After the stylesheet, so the font and colour tokens the defaults read are resolvable.
setUpCharts();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
